import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { CustomTerm, InputType, ProfanityFilterEnum, QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { ICustomTerm } from '../survey-editor/custom-terms.interface';
import { MonitorTerms } from '../survey-editor/monitor-terms-form.model';
import { QuestionForm } from './question-form.model';

export class QuestionFormInput extends QuestionForm {
  constructor() {
    super();
    this.extendFormGroup();
  }

  initEmpty(index: number, pageId: string): void {
    super.initEmpty(index, pageId);
    this.form.get('type').setValue(QuestionType.Input);
  }

  init(question: Question): void {
    super.init(question);
    this.form.get('type').setValue(QuestionType.Input);

    if (question.monitorTerms) {
      this.patchBlockTerms(question.monitorTerms.blockedTerms);
      this.patchFlagTerms(question.monitorTerms.flaggedTerms);
    }
  }

  private extendFormGroup(): void {
    this.form.addControl('inputType', new FormControl<InputType>(InputType.Text));
    this.form.addControl('maxLength', new FormControl<number>(0));
    this.form.addControl('minLength', new FormControl<number>(0));
    this.form.addControl('maxTextLength', new FormControl<number>(0));
    this.form.addControl('minTextLength', new FormControl<number>(0));
    this.form.addControl(
      'monitorTerms',
      new FormGroup<MonitorTerms>({
        monitorProblematicInd: new FormControl<boolean>(false),
        flagCurseWordsInd: new FormControl<ProfanityFilterEnum>(ProfanityFilterEnum.Disabled),
        flagGibberishInd: new FormControl<boolean>(false),
        customErrorMessage: new FormControl<string>(''),
        customErrorMessageInd: new FormControl<boolean>(false),
        blockedTerms: new FormArray<FormGroup<ICustomTerm>>([new FormGroup<ICustomTerm>({ type: new FormControl('contains'), term: new FormControl('') })]),
        flaggedTerms: new FormArray<FormGroup<ICustomTerm>>([new FormGroup<ICustomTerm>({ type: new FormControl('contains'), term: new FormControl('') })])
      })
    );
  }
}
